import { useTranslation } from "react-i18next";
import { IconBack } from "../../../common/icons/IconBack/IconBack";
import defaultContent from "../../../content/profile";
import commonContent from "../../../content/common";
import { useAppDispatch, useAppSelector } from "../../../store";
import { hideApplicant } from "../../../reducers/profile";
import LeafPanel from "../../../common/leaf/LeafPanel/LeafPanel";
import ABOApplicantBody from "./ABOApplicantBody/ABOApplicantBody";
import "./ABOApplicantSlider.scss";

const ABOApplicantSlider = () => {
  const { t } = useTranslation(["profile", "common"]);
  const isShowApplicant = useAppSelector((state) => state.profile.isShowApplicant);
  const profileType = useAppSelector((state) => state.profile.profileType);
  const dispatch = useAppDispatch();

  const showSlider = isShowApplicant && profileType === "abo";

  const closeApplicant = () => {
    dispatch(hideApplicant());
  };

  return (
    <LeafPanel
      title={`${t("aboProfile.aboApplicants.title", defaultContent["aboProfile"]["aboApplicants"]["title"])}`}
      show={showSlider}
      onCloseClick={closeApplicant}
      id={"abo-applicant-slider"}
      exitIcon={<IconBack width="0.8125rem" height="1.25rem" />}
      exitIconAriaLabel={`${t("common:backButton", commonContent["backButton"])}`}
      background="veryLightGrey"
      showBackdrop={false}
    >
      <ABOApplicantBody isShowApplicant={showSlider} />
    </LeafPanel>
  );
};

export default ABOApplicantSlider;
